// extracted by mini-css-extract-plugin
module.exports = {"container":"e_oC","label":"e_pC","image":"e_qC","name":"e_rC","description":"e_sC","descriptionCollapsed":"e_tC","bottomLine":"e_uC","socialIcon":"e_vC"};